import { createSlice } from '@reduxjs/toolkit';
import { addNewResult, editResult, getAllResults } from './resultService';

const initialState = {
  allResults: {
    isResultsLoading: null,
    isResultsSuccess: null,
    resultsMessage: null,
    pageCount: 0,
    results: [],
  },
  newResult: {
    isResultCreating: null,
    isResultCreated: null,
    resultCreationMsg: null,
  },

  editedResult: {
    isEditingResult: null,
    isResultEdited: null,
    resultEditedMsg: null
  }
};

const resultsSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllResults.pending, (state) => {
        state.allResults = {
          ...initialState.allResults, // Reset to initial state
          isResultsLoading: true,
          resultsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllResults.rejected, (state, action) => {
        state.allResults = {
          ...initialState.allResults,
          isResultsLoading: false,
          isResultsSuccess: false,
          resultsMessage: action.payload || 'Error occurred while fetching results',
        };
      })

      // FULFILLED
      .addCase(getAllResults.fulfilled, (state, action) => {
        state.allResults = {
          ...initialState.allResults,
          isResultsLoading: false,
          isResultsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          results: action.payload.data || [],
        };
      });

    //Result creating
    builder
      .addCase(addNewResult.pending, (state) => {
        state.newResult = {
          ...initialState.newResult, // Reset to initial state
          isResultCreating: true,
          resultCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewResult.rejected, (state, action) => {
        state.newResult = {
          ...initialState.newResult,
          isResultCreating: false,
          isResultCreated: false,
          resultCreationMsg: action.payload || 'Error occurred while creating the result.',
        };
      })

      // FULFILLED
      .addCase(addNewResult.fulfilled, (state, action) => {
        state.newResult = {
          ...initialState.newResult,
          isResultCreating: false,
          isResultCreated: true,
          resultCreationMsg: action.payload || 'Successfully created the result.',
        };
      });

    //Result editing
    builder
      .addCase(editResult.pending, (state) => {
        state.editedResult = {
          ...initialState.editedResult, // Reset to initial state
          isEditingResult: true,
          resultEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editResult.rejected, (state, action) => {
        state.editedResult = {
          ...initialState.editedResult, // Reset to initial state
          isEditingResult: false,
          isResultEdited: false,
          resultEditedMsg: action.payload || 'Error occurred while editing the result.',
        };
      })

      // FULFILLED
      .addCase(editResult.fulfilled, (state, action) => {
        state.editedResult = {
          ...initialState.editedResult, // Reset to initial state
          isEditingResult: false,
          isResultEdited: true,
          resultEditedMsg: action.payload || 'Successfully edited the result.',
        };
      });
  },
});

export default resultsSlice.reducer;
